import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import componentColor, { dls, smartQareExtendedPalette } from '../compat/colors';
import { Button } from '../compat/core';
import { BrandLogo } from '../components/BrandLogo';
import { SplashTheme } from '../dls/SplashScreen/SplashTheme';
import { PRODUCT_NAME } from '../branding/constants';

type Props = {
  onLogout: () => void;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100vw;
  min-height: 100vh;
  background: radial-gradient(
    circle farthest-side,
    ${componentColor(dls.light.lightCenter.default.normal)},
    ${componentColor(dls.light.lightEdge.default.normal)}
  );
  background-attachment: fixed;
  background-color: ${componentColor(dls.loginScreen.background.default.normal)};
  background-size: cover;
  color: ${componentColor(dls.loginScreen.text.default.normal)};
`;

const SplashBrandLogo = styled(BrandLogo).attrs({
  variant: 'full',
  size: 'lg',
})`
  width: min(76vw, 280px);
  min-width: 160px;
  height: auto;
  margin: calc((70.8vh - 48px) / 2) 0 14.6vh;
`;

const Title = styled.h1`
  margin: 0 0 16px;
  font-size: 24px;
  font-style: normal;
  font-weight: 300;
`;

const MessageBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  max-width: 480px;
  padding: 0 24px;
  text-align: center;
`;

const SubText = styled.p`
  margin: 0;
  color: ${smartQareExtendedPalette.textOnDarkSecondary};
  font-size: 16px;
  line-height: 1.5;
`;

export const UserNotFoundPage: FunctionComponent<Props> = ({ onLogout }) => (
  <SplashTheme>
    <Container>
      <SplashBrandLogo />
      <MessageBox>
        <Title>{PRODUCT_NAME}</Title>
        <SubText>
          <FormattedMessage
            id="userNotFound.message"
            defaultMessage="Your account was not found in the system. Please contact your local administrator to get access."
          />
        </SubText>
        <Button dls_variant="primary" type="button" onClick={onLogout}>
          <FormattedMessage id="actions.logout" defaultMessage="Log out" />
        </Button>
      </MessageBox>
    </Container>
  </SplashTheme>
);
